import React from 'react';
import {
  ShieldCheck, Snowflake, Activity, FlaskConical, HeartPulse, Moon, Wind,
} from 'lucide-react';
import { PillarHub } from './PillarHub';
import { BiminiPartnerFeature } from '../components/partners/BiminiPartnerFeature';
import { BiminiAwarenessPopup } from '../components/partners/BiminiAwarenessPopup';

export default function RecoveryHubPage() {
  return (
    <>
    <PillarHub
      testid="recovery-hub"
      pillar="Recovery"
      category="Recovery"
      eyebrow="The Recovery Pillar"
      headline="Recover faster. Train harder. Stay healthy."
      subhead="Evidence-based protocols for cold plunge, hydrotherapy, sleep, peptide-assisted healing and active recovery — written by athletes, grounded in peer-reviewed research."
      primaryCta={{
        label: 'Read the recovery guide',
        href: '/blogs/article/cold-exposure-benefits',
      }}
      trustSignals={[
        { icon: ShieldCheck, label: 'Evidence-based', detail: 'NIH / PubMed-cited sources' },
        { icon: HeartPulse, label: 'PubMed-cited', detail: '50+ peer-reviewed studies' },
        { icon: FlaskConical, label: 'Peptide stacks',  detail: 'BPC-157 · TB-500 · KPV' },
        { icon: Snowflake, label: 'Tested protocols', detail: 'Cold · Sauna · Compression' },
      ]}
      tools={[
        { label: 'Heart-Rate Zones', href: '/tools/heart-rate-zones', icon: Activity },
        { label: 'Cycle Tracker',    href: '/tools/peptide-cycle-tracker', icon: FlaskConical },
        { label: 'Sleep Reset Tool', href: '/tools/longevity-score', icon: Moon },
        { label: 'Breathwork Timer', href: '/timers', icon: Wind },
      ]}
      fallbackTagMatches={['recovery', 'cold-plunge', 'sauna', 'hydrotherapy', 'bpc-157', 'tb-500']}
      locatorFeeder={{
        heading: 'Find recovery therapy near you',
        blurb: 'Cold plunge, contrast suites, compression lounges — 540+ vetted facilities across 25 metros in our free locator.',
        therapies: [
          { slug: 'cold-plunge', name: 'Cold Plunge' },
          { slug: 'contrast-therapy', name: 'Contrast Therapy' },
          { slug: 'compression-therapy', name: 'Compression' },
        ],
      }}
      bgVideo="https://customer-assets.emergentagent.com/job_b243a8fb-e07a-4745-aa9b-1afaf42d31b2/artifacts/3mpp5dca_Elite_athlete_entering_hydroth_Kling_30__88665.mp4"
      partnerFeature={<BiminiPartnerFeature placementId="recovery-hub" primaryHref="/hydrotherapy" />}
      extraGuides={[
        { title: 'Oxygen nanobubble hydrotherapy', href: '/hydrotherapy', category: 'Recovery', blurb: 'How it works, what a session involves, and every Bimini system by setting.' },
      ]}
    />
    <BiminiAwarenessPopup contextId="recovery-hub" />
    </>
  );
}
